import React from "react";
import NFLOddsReportTable from "./NFLOddsReportTable";
import "./NFLOddsReportPage.css";

export default function NFLOddsReportPage() {
  return (
    <div className="nfl-projections-container">
      <h1>NFL Odds Report</h1>
      <React.Suspense fallback="Loading odds...">
        <NFLOddsReportTable />
      </React.Suspense>
    </div>
  );
}
